export class Response {
  message: string | ArrayBuffer;
  OK: boolean;
  orgRes: any;

  constructor(message: string | ArrayBuffer, isOK: boolean = true, res?: any) {
    this.message = message;
    this.OK = isOK;
    this.orgRes = res;
  }
}
